var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FF0000",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6349 48.1351L43.4999 36.0001L55.6349 23.8651C55.8675 23.6297 55.9979 23.3122 55.9979 22.9813C55.9979 22.6505 55.8675 22.3329 55.6349 22.0976L49.9024 16.3651C49.7865 16.2487 49.6488 16.1564 49.4972 16.0935C49.3455 16.0305 49.1829 15.998 49.0187 15.998C48.8545 15.998 48.6919 16.0305 48.5402 16.0935C48.3886 16.1564 48.2508 16.2487 48.1349 16.3651L35.9999 28.5001L23.8649 16.3651C23.6305 16.1307 23.3127 15.9991 22.9812 15.9991C22.6497 15.9991 22.3319 16.1307 22.0974 16.3651L16.3649 22.0976C16.2486 22.2135 16.1563 22.3512 16.0933 22.5029C16.0303 22.6545 15.9979 22.8171 15.9979 22.9813C15.9979 23.1455 16.0303 23.3081 16.0933 23.4598C16.1563 23.6114 16.2486 23.7492 16.3649 23.8651L28.4999 36.0001L16.3649 48.1351C16.1306 48.3695 15.999 48.6874 15.999 49.0188C15.999 49.3503 16.1306 49.6682 16.3649 49.9026L22.0974 55.6351C22.2133 55.7514 22.3511 55.8437 22.5027 55.9067C22.6544 55.9697 22.817 56.0021 22.9812 56.0021C23.1454 56.0021 23.308 55.9697 23.4597 55.9067C23.6113 55.8437 23.749 55.7514 23.8649 55.6351L35.9999 43.5001L48.1349 55.6351C48.3694 55.8694 48.6872 56.0011 49.0187 56.0011C49.3502 56.0011 49.668 55.8694 49.9024 55.6351L55.6349 49.9026C55.7513 49.7867 55.8436 49.6489 55.9066 49.4973C55.9695 49.3456 56.002 49.183 56.002 49.0188C56.002 48.8546 55.9695 48.692 55.9066 48.5404C55.8436 48.3887 55.7513 48.251 55.6349 48.1351Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.25cc433e8ab9951913a94dd4b5a1ab62.svg";
export { ForwardRef as ReactComponent };